import React, { useId, useState } from "react";

/** Password input with a show / hide toggle. */
export default function PasswordField({
  label,
  value,
  onChange,
  autoComplete,
  disabled,
  hint,
  required = true,
}) {
  const [visible, setVisible] = useState(false);
  const id = useId();
  const hintId = hint ? `${id}-hint` : undefined;

  return (
    <div className="reg-field">
      <label className="reg-label" htmlFor={id}>
        {label}
        {required && <span className="reg-req"> *</span>}
      </label>
      <div className="acct-password">
        <input
          id={id}
          type={visible ? "text" : "password"}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          autoComplete={autoComplete}
          disabled={disabled}
          minLength={6}
          required={required}
          spellCheck={false}
          aria-describedby={hintId}
        />
        <button
          type="button"
          className="acct-password-toggle"
          onClick={() => setVisible((v) => !v)}
          aria-pressed={visible}
          aria-label={visible ? "Ocultar contraseña" : "Mostrar contraseña"}
          disabled={disabled}
        >
          {visible ? "Ocultar" : "Mostrar"}
        </button>
      </div>
      {hint && (
        <span className="reg-hint" id={hintId}>
          {hint}
        </span>
      )}
    </div>
  );
}
